import Layout from '@/layout';
var adRouter = {
  path: '/ad',
  component: Layout,
  redirect: '/ad/placement/banner',
  name: 'Ad',
  meta: {
    title: '广告管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'placement/banner',
    name: 'PlacementBanner',
    component: function component() {
      return import('@/views/ad/placement/banner/page.vue');
    },
    meta: {
      title: '广告位设置',
      icon: ''
    }
  }]
};
export default adRouter;